import { Autocomplete, styled } from "@mui/material";

export const CustomAutocomplete = styled(Autocomplete)`
  & .MuiInputBase-root {
    flex-wrap: nowrap;
  }
`;
